module.exports = require("./kab-DZ");